<template>
	<div
	v-touch:tap="tapHandler"
	@keyup.enter="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	class="list-group-item"
	style="user-select: none; cursor: pointer;"
	tabindex="0"
	role="link"
	>
		<button class="btn btn-danger float-right ml-2" v-if="showDeleteBtn" v-touch:tap.stop="deleteFormResponse">{{$t('delete')}}</button>
		<button class="btn btn-secondary float-right" v-if="showAbandonBtn" v-touch:tap.stop="abandonFormResponse">{{$t('abandon')}}</button>

		<p class="mb-0">
			<template v-if="item.savedreport">
				<strong class="mr-2">
					<template v-if="item.num_users > 1">
						<template v-if="item.savedreport.savedreport_title">
							{{item.savedreport.savedreport_title}}:
						</template>
						<template v-else>
							{{$t('report-for')}}
						</template>
						{{item.num_users}} {{$t('students')}}
					</template>
					<template v-else>
						<template v-if="item.savedreport.savedreport_title">
							{{item.savedreport.savedreport_title}}: {{ item.savedreport.student_displayname }}
						</template>
						<template  v-else>
							{{$t('report-for')}} {{ item.savedreport.student_displayname }}
						</template>
					</template>
				</strong>
			</template>
			<template v-else>
				<strong class="mr-2">{{ item.formresponse_data.title }}</strong>
			</template>
			<span v-if="(item.formresponse_abandoned == '1')" class="badge badge-secondary">{{$t('abandoned')}}</span>
			<br />
			<span class="small">
				<template v-if="Number(item.formresponse_completed) == 1 && item.formresponse_dateofresponse">
					{{ this.$datetime.getLocaleStringFromTimeStamp(item.formresponse_dateofresponse, false) }}
				</template>
				<template v-else>
					{{ this.$datetime.getLocaleStringFromTimeStamp(item.created, false) }}
				</template>
			</span>
			<span class="badge" :class="deadlineClass" v-if="showDeadline">{{ $t('deadline-colon') }} {{ this.$datetime.getLocaleStringFromTimeStamp(item.formresponse_deadline, false) }}</span>
			<br />
			<template v-if="item.formresponse_message">
				<span class="small">{{ $stringhelper.truncate(item.formresponse_message, 250, '...') }}</span>
				<br />
			</template>
			<span class="small">
				{{ $t('user-colon') }} <strong>{{ item.user_displayname }}</strong>
				<template v-if="item.userreview_displayname">
					<template v-if="(item.formresponse_reviewed == '1')">
						<span class="badge badge-pill badge-success ml-1">
							{{ $t('reviewed-by') }}
							<strong>{{item.userreview_displayname }}</strong>
						</span>
					</template>
					<template v-else>
						<span class="text-subtle ml-1">&#183;</span>
						{{ $t('review-colon') }} <strong>{{ item.userreview_displayname }}</strong>
					</template>
				</template>
				<template v-if="item.usersignoff_displayname">
					<template v-if="(item.formresponse_signedoff == '1')">
						<span class="badge badge-pill badge-success ml-1">
							{{ $t('signed-off-by') }}
							<strong>{{ item.usersignoff_displayname }}</strong>
						</span>
					</template>
					<template v-else>
						<span class="text-subtle ml-1">&#183;</span>
						{{ $t('signoff-colon') }}
						<strong>{{ item.usersignoff_displayname }}</strong>
					</template>
				</template>
				<template v-if="awaitingFeedbackFromDisplayName">
				<br /><span class="text-subtle">{{ $t('awaiting-feedback-from-colon') }} <strong>{{ awaitingFeedbackFromDisplayName }}</strong></span>
			</template>
		</span>
		</p>

	</div>
</template>

<script>
export default {
	name: "FormsWidgetItem",
	props: ['item', 'list', 'swipedLeftItem'],
	data() {
		return {
		};
	},
	methods: {
		abandonFormResponse() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/abandon`, {
				data: {
					id: this.item.formresponse_id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		deleteFormResponse() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/delete`, {
				data: {
					id: this.item.formresponse_id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {

			// prevent tap for right clicks
			if(e.button && e.button == 2) {
				return false;
			}

			if(this.item.savedreport && this.item.num_users > 1){
				this.$router.push(`/forms/list?savedreport=${this.item.savedreport.savedreport_id}&completed=n&submitter=${this.$UserSession.getValue('id')}`);
			} else {
				this.$router.push(`/forms/view/${this.item.formresponse_id}`);
			}

		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.item);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.item);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.item);
		}
	},
	computed: {
		showDeadline() {
			if(this.item.formresponse_deadline){
				if(this.item.formresponse_completed == 0){
					return true;
				}
			}
			return false;
		},
		awaitingFeedbackFromDisplayName() {
			const me = this.$UserSession.getValue('id');
			const fr = this.item;
			if(fr.formresponse_completed != '1' && fr.user_id != me) {
				return fr.user_displayname;
			} else if(fr.formresponse_completed == '1' && fr.formresponse_signedoff != '1' && fr.usersignofffrom_id != me) {
				return fr.usersignoff_displayname;
			}
			return null;
		},
		deadlineClass(){
			var now = Date.now() / 1000;
			if(this.item.formresponse_deadline < now){
				return 'badge-danger';
			}
			if(this.item.formresponse_deadline < now + (3600*24*3)){
				return 'badge-warning';
			}
			return 'badge-info';
		},
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.formresponse_id == this.item.formresponse_id)
			&&
			(
				(
					this.$UserSession.getValue('id') == this.item.userfrom_id && this.item.formresponse_reviewed != '1' && this.item.formresponse_signedoff != '1'
				)
				|| this.$UserSession.hasPriv.call(this, "EDIT_ALLFORMS")
			);
		},
		showAbandonBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.formresponse_id == this.item.formresponse_id)
			&& this.item.formresponse_signedoff != '1' && this.item.formresponse_abandoned != '1'
			&& (
				[this.item.usersignofffrom_id, this.item.userfrom_id].includes(this.$UserSession.getValue('id'))
				||
				this.$UserSession.hasPriv.call(this, "EDIT_ALLFORMS")
			);
		}
	}
};
</script>
